import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, "ID", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }

import { ref, onMounted, inject } from "vue";
import { InfoFilled } from "@element-plus/icons-vue";
import ToolServices from "../services/ToolServices";
import { ElNotification } from "element-plus";
import BlockListCreate from "../components/BlockListCreate.vue";
import BlockListExport from "../components/BlockListExport.vue";
import BlockListImport from "../components/BlockListImport.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'BlockedList',
  setup(__props) {

const isLoading = inject<any>("isLoading");
const selectedOption = ref("email");
const detail = ref(Array<any>());
const createModalRef = ref(null);
const exportModalRef = ref<any>(null);
const importModalRef = ref<any>(null);
const criteria = ref({
  page: 1,
  size: 25,
});

const inputValue = ref("");

const search = () => {
  delete criteria.value.email;
  delete criteria.value.phone;
  delete criteria.value.name;
  delete criteria.value.idNumber;
  criteria.value[selectedOption.value] = inputValue.value;
  fetchData(1);
};

const reset = () => {
  criteria.value = { page: 1, size: 25 };
  inputValue.value = "";
  fetchData(1);
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  try {
    const data = await ToolServices.getBlockedList(criteria.value);
    criteria.value = data.criteria;
    detail.value = data.data;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const showCreate = (item?: any) => {
  createModalRef.value?.show(item);
};
const removeBlockedUser = async (id: number) => {
  try {
    await ToolServices.removeBlockedUser(id);
    ElNotification.success({
      title: "Success",
      message: "User removed from blocked list successfully.",
      offset: 100,
    });
    fetchData(1);
  } catch (error) {
    console.log(error);
    ElNotification.error({
      title: "Error",
      message: error.message,
      offset: 100,
    });
  }
};

onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_select, {
            modelValue: selectedOption.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOption).value = $event)),
            placeholder: "Select option",
            class: "w-150px me-3",
            disabled: _unref(isLoading)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "Email",
                value: "email"
              }),
              _createVNode(_component_el_option, {
                label: "Name",
                value: "name"
              }),
              _createVNode(_component_el_option, {
                label: "Phone",
                value: "phone"
              }),
              _createVNode(_component_el_option, {
                label: "ID Number",
                value: "idNumber"
              })
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"]),
          _createVNode(_component_el_input, {
            class: "w-200px me-3",
            modelValue: inputValue.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputValue).value = $event)),
            disabled: _unref(isLoading)
          }, null, 8, ["modelValue", "disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: search,
            plain: "",
            disabled: _unref(isLoading)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            onClick: reset,
            plain: "",
            disabled: _unref(isLoading)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (importModalRef.value?.show())),
            type: "danger"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Import")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (exportModalRef.value?.show())),
            type: "success"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Export")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (showCreate()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Block User")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.name")), 1),
              _hoisted_7,
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.phone")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.operator")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (_unref(isLoading))
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!_unref(isLoading) && detail.value?.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_UserInfo, {
                          email: item.email,
                          name: item.name,
                          class: "me-2"
                        }, null, 8, ["email", "name"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.idNumber), 1),
                      _createElementVNode("td", null, _toDisplayString(item.phone), 1),
                      _createElementVNode("td", null, _toDisplayString(item.operatorName), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: ($event: any) => (showCreate(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_popconfirm, {
                          "confirm-button-text": "Yes",
                          "cancel-button-text": "No",
                          icon: _unref(InfoFilled),
                          "icon-color": "#626AEF",
                          title: "Remove this user from blocked list",
                          onConfirm: ($event: any) => (removeBlockedUser(item.id)),
                          width: "300px"
                        }, {
                          reference: _withCtx(() => [
                            _createVNode(_component_el_button, { type: "danger" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.remove")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["icon", "onConfirm"])
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(BlockListCreate, {
      ref_key: "createModalRef",
      ref: createModalRef,
      onEventSubmit: _cache[5] || (_cache[5] = ($event: any) => (fetchData(1)))
    }, null, 512),
    _createVNode(BlockListExport, {
      ref_key: "exportModalRef",
      ref: exportModalRef,
      criteria: criteria.value
    }, null, 8, ["criteria"]),
    _createVNode(BlockListImport, {
      ref_key: "importModalRef",
      ref: importModalRef,
      onImported: _cache[6] || (_cache[6] = ($event: any) => (fetchData(1)))
    }, null, 512)
  ], 64))
}
}

})